export const PickingMissionModelAgeInDays = {
    0: "j-0",
    1: "j-1",
    2: "j-2",
    3: "j-3",
    4: ">j-3"
}